import clsx from "clsx";
import {
  Box,
  makeStyles,
  Typography,
  Card,
} from "@material-ui/core";
import Page from "src/components/Page";
import React from "react";
import CookiesPolicy from "src/components/common/CookiesPolicy";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(2),
    },
  },
}));

const CookiesPolicyView = (rest) => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Polityka prywatności">

      <Box mt={3}>
        <Card className={clsx(classes.root)}>
          <Box display="flex" flexDirection="column">
            <Box>
              <Typography
                color="textPrimary"
                component="h1"
                variant="h2"
                align="center"
                paragraph
              >
                Polityka prywatności
              </Typography>
              <CookiesPolicy></CookiesPolicy>
            </Box>
          </Box>
        </Card>
      </Box>
    </Page>
  );
};

export default CookiesPolicyView;
